(() => {
  const name = 'prescriptionState';

  App.common = App.common || {};

  App.common[name] = (() => {
    const setCookie = (sName, sValue, expires) => {
      App.global.setCookie(sName, sValue, '/', expires);
    };

    const getCookieName = (productType) => {
      switch (productType) {
        case App.product.Type.LENS:
          return 'lensPrescriptionState';
        default:
          return null;
      }
    };

    const getState = (productType) => App.global.getCookie(getCookieName(productType));

    const saveState = (prescriptionState, productType) => {
      setCookie(getCookieName(productType), prescriptionState, new Date(Date.now() + 60 * 60 * 1000));
    };

    const init = () => {
    };

    return {
      getState,
      init,
      saveState,
    };
  })();
})();
